import { AppEnv } from './appEnv';
import { ApiGatewayUrl, apiGatewayUrl, BffUrl, bffUrl } from './url/apiUrl';
import { AssetsCdnUrl, assetsCdnUrl } from './url/cdnUrl';
import {
  JobNurseSenkaUrl,
  jobNurseSenkaUrl,
  NjbUrl,
  njbUrl,
  recruitNurseSenkaUrl,
  RecruitNurseSenkaUrl,
} from './url/externalUrl';
import {
  AccountUrl,
  accountUrl,
  FortuneTellingUrl,
  fortuneTellingUrl,
  KnowledgeNurseSenkaUrl,
  knowledgeNurseSenkaUrl,
  LoungeUrl,
  loungeUrl,
  MedicalTerm,
  medicalTerm,
  NurseSquareUrl,
  nurseSquareUrl,
  PortalUrl,
  portalUrl,
  RecruitUrl,
  recruitUrl,
  SurveyUrl,
  surveyUrl,
  WorkplaceReputationUrl,
  workplaceReputationUrl,
  InsuranceUrl,
  insuranceUrl,
} from './url/frontendUrl';
import { DefaultProfileImageUrl, defaultProfileImageUrl } from './url/imageUrl';

export type NurseSenkaAllUrl = {
  assetsCdn: AssetsCdnUrl;
  defaultProfileImageUrl: DefaultProfileImageUrl;
  portal: PortalUrl;
  account: AccountUrl;
  fortuneTelling: FortuneTellingUrl;
  workplaceReputation: WorkplaceReputationUrl;
  recruit: RecruitUrl;
  nurseSquare: NurseSquareUrl;
  knowledgeNurseSenka: KnowledgeNurseSenkaUrl;
  lounge: LoungeUrl;
  medicalTerm: MedicalTerm;
  survey: SurveyUrl;
  insuranceUrl: InsuranceUrl;
  jobNurseSenka: JobNurseSenkaUrl;
  recruitNurseSenka: RecruitNurseSenkaUrl;
  njb: NjbUrl;
  apiGateway: ApiGatewayUrl;
  bff: BffUrl;
};

export const nurseSenkaAllUrl = (appEnv: AppEnv): NurseSenkaAllUrl => ({
  assetsCdn: assetsCdnUrl(appEnv),
  defaultProfileImageUrl: defaultProfileImageUrl(appEnv),
  portal: portalUrl(appEnv),
  account: accountUrl(appEnv),
  fortuneTelling: fortuneTellingUrl(appEnv),
  workplaceReputation: workplaceReputationUrl(appEnv),
  recruit: recruitUrl(appEnv),
  nurseSquare: nurseSquareUrl(appEnv),
  knowledgeNurseSenka: knowledgeNurseSenkaUrl(appEnv),
  lounge: loungeUrl(appEnv),
  medicalTerm: medicalTerm(appEnv),
  survey: surveyUrl(appEnv),
  insuranceUrl: insuranceUrl(appEnv),
  jobNurseSenka: jobNurseSenkaUrl(appEnv),
  recruitNurseSenka: recruitNurseSenkaUrl(appEnv),
  njb: njbUrl(appEnv),
  apiGateway: apiGatewayUrl(appEnv),
  bff: bffUrl(appEnv),
});

export type HttpsUrl = `https://${string}`;
